import React from "react";
import { Typography } from "design_system/src";
import motoLoading from "../static/gifs/loading_moto.gif";


export const LoadingScreen = () => (
  <div className="dim_100_vp flex_center">
  <img src={motoLoading} alt="" className="h_xxxl" />
  <Typography scale="large" weight="600" className="text_center">Cargando...</Typography>

  </div>
);
